'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var he = {
  code: "he",
  direction: "rtl",
  buttonText: {
    prev: "\u05D4\u05E7\u05D5\u05D3\u05DD",
    next: "\u05D4\u05D1\u05D0",
    today: "\u05D4\u05D9\u05D5\u05DD",
    month: "\u05D7\u05D5\u05D3\u05E9",
    week: "\u05E9\u05D1\u05D5\u05E2",
    day: "\u05D9\u05D5\u05DD",
    list: "\u05E1\u05D3\u05E8 \u05D9\u05D5\u05DD"
  },
  allDayText: "\u05DB\u05DC \u05D4\u05D9\u05D5\u05DD",
  moreLinkText: "\u05D0\u05D7\u05E8",
  noEventsText: "\u05D0\u05D9\u05DF \u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD \u05DC\u05D4\u05E6\u05D2\u05D4",
  weekText: "\u05E9\u05D1\u05D5\u05E2"
};

exports.default = he;
